import { Label, TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';

import { ECategory } from './types';

export const formatMoney = (m: number, cur: string): string =>
  `${m.toLocaleString(undefined, { maximumFractionDigits: 2 })} ${cur}`;

export const getCategoryLabel = (
  category: ECategory,
  t: TTranslator<TLocalesKeys>
): JSX.Element | null => {
  if (category === 'DEPOSIT') {
    return (
      <Label
        text={t('payments.category.deposit')}
        color="violet"
        iconName="WalletIcon"
        rounded
      />
    );
  }
  if (category === 'BONUS') {
    return (
      <Label text={t('bonus')} color="orange" iconName="BonusIcon" rounded />
    );
  }
  if (category === 'TARIFF') {
    return (
      <Label text={t('tariff')} color="blue" iconName="ClockIcon" rounded />
    );
  }
  if (category === 'GOOD') {
    return <Label text={t('good')} color="green" iconName="ShopIcon" rounded />;
  }
  if (category === 'SERVICE') {
    return (
      <Label
        text={t('service')}
        color="gray-primary"
        iconName="PrinterIcon"
        rounded
      />
    );
  }
  if (category === 'CLOUD_PAYMENTS') {
    return (
      <Label
        text="CloudPayments"
        color="red"
        iconName="CloudPaymentsIcon"
        rounded
      />
    );
  }

  if (category === 'TINKOFF_SBP') {
    return <Label rounded color="pink" iconName="SBPIcon" text={t('sbp')} />;
  }

  if (category === 'KASPI_PAY') {
    return (
      <Label rounded color="blue" iconName="KaspiIcon" text="Kaspi-онлайн" />
    );
  }

  if (category === 'STRIPE') {
    return (
      <Label
        text="Stripe"
        color="violet-stripe"
        iconName="StripeIcon"
        rounded
      />
    );
  }

  if (category === 'BEPAID_ERIP') {
    return (
      <Label
        text="bePaid"
        color="gray-secondary"
        iconName="BePaidIcon"
        rounded
      />
    );
  }
  return null;
};
